import { privGetRequest } from "../vidCloud/priv";

const DisclaimerService = {};

DisclaimerService.getDisclaimer = (signerGuid, type) => {
  const lang = localStorage.getItem("i18nextLng");
  return privGetRequest(`/pendingsignatures/${signerGuid}/disclaimertext/${type}/${lang}`);
}

export default DisclaimerService;